<template>
  <ContentSection
    :spacing="isSustainabilityArticleWithSidebar ? 'sm-margin' : 'default'"
  >
    <Container
      :indent="isSustainabilityArticleWithSidebar ? 'none' : 'center'"
      :class="{
        'sm:px-container lg:px-container-desktop':
          !isSustainabilityArticleWithSidebar,
      }"
    >
      <div
        class="flex flex-col bg-gradient-to-tr from-[#F7FBFE] to-[#EFF6FA] lg:flex-row"
      >
        <!-- TEXT -->
        <div class="px-container-wide pt-8 sm:p-8 lg:w-2/5 xl:p-12">
          <!-- Title -->
          <h2 class="mb-4 text-md font-medium">
            <ClientOnly>
              {{
                data.title ||
                (showContactPerson
                  ? $t('location_and_contact_of_project')
                  : $t('location_of_project'))
              }}
              <template #fallback>
                {{ data.title || $t('location_of_project') }}
              </template>
            </ClientOnly>
          </h2>

          <!-- Address -->
          <div
            @mouseenter="isHoveringAddress = true"
            @mouseleave="isHoveringAddress = false"
          >
            <p v-if="page.location_name">{{ page.location_name }}</p>
            <AppLink
              v-if="page.location_address"
              :to="page.location_link_to_map"
              class="whitespace-pre-line font-normal"
              target="_blank"
            >
              {{ page.location_address }}
            </AppLink>
          </div>

          <!-- Contact -->
          <ClientOnly>
            <div v-if="showContactPerson" class="mt-3">
              <p class="mb-1">{{ page.contact_name }}</p>
              <AppLink
                v-if="page.contact_phone"
                :to="`tel:${page.contact_phone}`"
                class="font-normal"
              >
                {{ page.contact_phone }}
              </AppLink>
              <AppLink
                v-if="page.contact_email"
                :to="`mailto:${page.contact_email}`"
                class="font-normal"
              >
                {{ page.contact_email }}
              </AppLink>
            </div>
          </ClientOnly>
        </div>

        <div class="p-5 lg:w-3/5">
          <!-- MAP -->
          <div class="relative aspect-[920/600]">
            <img
              src="~/assets/images/swiss-map.svg"
              :alt="$t('accessibility.swiss_map')"
            />
            <div
              class="absolute"
              :style="{
                left: `${page.location_marker_position_x || 50}%`,
                top: `${page.location_marker_position_y || 50}%`,
              }"
            >
              <a
                :href="page.location_link_to_map"
                target="_blank"
                :aria-label="page.location_address"
                class="group"
              >
                <MarkerIconFat
                  class="h-7 origin-bottom text-blue-800 transition-transform ease-in-out group-hover:scale-150"
                  :class="{
                    'scale-150': isHoveringAddress,
                  }"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
import { useAuthStore } from '~/stores/auth.js'

const props = defineProps({
  data: { type: Object, required: true },
})

const page = inject('page', null)

const { isMember, isRegularMember } = useAuthStore()

const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

const isHoveringAddress = ref(false)

const showContactPerson = computed(() => {
  const visibility = page.value?.contact_visibility?.value

  switch (visibility) {
    case 'all':
      return true
    case 'members':
      return isMember || isRegularMember
    case 'regular_members':
      return isRegularMember
  }
})
</script>
